import { render, staticRenderFns } from "./LuFundingSponsorGrid.vue?vue&type=template&id=2a132be4&"
import script from "./LuFundingSponsorGrid.vue?vue&type=script&lang=js&"
export * from "./LuFundingSponsorGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_babel-co_0dbbf42f62185882c0604707ed980ddd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports